import { Component, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TileLayoutComponent } from '@progress/kendo-angular-layout';
import { last, takeUntil } from 'rxjs';
import { BaseComponent } from '../../../core/models/base-component.model';
import { Response } from '../../../core/interfaces/response.interface';
import { MiscellaneousItemService } from '../services/miscellaneous-item-service';
import { MiscellaneousItemSearchResult } from '../../../shared/interfaces/gridrows/miscellaneous-item-search-result.interface';

@Component({
    selector: 'app-miscellaneous-item-list',
    templateUrl: './miscellaneous-item-list.component.html',
    styleUrls: ['./miscellaneous-item-list.component.css'],
    standalone: false
})

export class MiscellaneousItemListComponent extends BaseComponent implements OnInit {

  @ViewChild("tileContainer", { static: true }) public tileContainer: TileLayoutComponent;

  public entity: MiscellaneousItemSearchResult;

  constructor(private router: Router, private MiscellaneousItemService: MiscellaneousItemService) { super(); }

  ngOnInit(): void {

    try {
      this.MiscellaneousItemService.getMiscellaneousItemOptions()
        .pipe(takeUntil(this.subscription))
        .subscribe({
          next: (data) => {
            this.entity = data;
          }
        });
    } catch (err) {
      console.log(err);
    }
  }

  navigateTo(endpoint: string) {
    this.router.navigate([endpoint]);
  }

  checkoutMiscellaneousItem(id: number) {
    //redirect to checkout the box or label
    this.router.navigate(['/BoxesLabel/CheckOutMiscellaneousItem/' + id]);
  }

}
